import { ecbrRequest } from '../../request/ecbrRequest'

export const files = {
  getById: async (id) => ecbrRequest.get(`/files/${id}`)
}
